import { AdvancedSearch as AdvancedSearchModel } from '../../../model/search/advanced/AdvancedSearch';
import { SearchContext, SearchMode } from '../../../model/search/ISearch';
import { Factory } from '../../../services/Factory';


export interface ISearchScope extends angular.IScope {
  advancedSearch: AdvancedSearchModel;
  searchMode: SearchMode;
  searchContext: SearchContext;
  project;
  collection: any;
}

export interface ISearchAttributes extends angular.IAttributes {
  height: number;
}

export class AdvancedSearch implements angular.IDirective {
  public restrict = "E";
  public templateUrl: string;
  public scope = {};
  public link: (scope: ISearchScope, element: angular.IAugmentedJQuery, attrs: ISearchAttributes) => void;


  constructor($rootScope: angular.IRootScopeService, projectService: app.services.project.ProjectService, collectionService: app.services.collections.CollectionService) {
    this.templateUrl = "partials/search/advanced/search.html";
    this.link = (scope: ISearchScope, element: angular.IAugmentedJQuery, attrs: ISearchAttributes) => {
      scope.searchContext = SearchContext.Project;
      scope.advancedSearch = new AdvancedSearchModel(scope.searchContext);
      scope.project = projectService.GetCurrentProject();
      scope.collection = collectionService.GetCurrentCollection();

      // With replace:true gone, element is the <iio-advanced-search> wrapper.
      // The show/hide animation targets the inner div (first child) so that the
      // height/opacity transitions work correctly.
      // Use children('div') rather than children().first() to skip any <script>
      // tags injected by the dev server (e.g. Vite's HMR client).
      const panel = element.children('div').first();

      let show = () => {
        panel
          .css("-webkit-transition", "height 0.3s, opacity 0.5s 0.3s")
          .css("-moz-transition", "height 0.3s, opacity 0.5s 0.3s")
          .css("-ms-transition", "height 0.3s, opacity 0.5s 0.3s")
          .css("-o-transition", "height 0.3s, opacity 0.5s 0.3s")
          .css("transition", "height 0.3s, opacity 0.5s 0.3s");

        panel.on("transitionend webkitTransitionEnd oTransitionend MStransitionEnd", () => {
          panel.css("overflow", "hidden");
        });

        panel.height(attrs.height);
        panel.css("opacity", "1");
      };

      let hide = () => {
        panel
          .css("-webkit-transition", "height 0.3s 0.3s, opacity 0.5s")
          .css("-moz-transition", "height 0.3s 0.3s, opacity 0.5s")
          .css("-ms-transition", "height 0.3s 0.3s, opacity 0.5s")
          .css("-o-transition", "height 0.3s 0.3s, opacity 0.5s")
          .css("transition", "height 0.3s 0.3s, opacity 0.5s");

        panel.off("transitionend webkitTransitionEnd oTransitionend MStransitionEnd");
        panel.css("overflow", "hidden");
        panel.height(0);
        panel.css("opacity", "0");
      };

      scope.$watch("searchMode", mode => {
        if (mode == SearchMode.Advanced) {
          show();
        } else {
          hide();
          scope.$broadcast("SearchMode.Basic");
        }
      });

      scope.$on("ProjectService.CurrentProjectChanged", (event, project) => scope.project = project);

      scope.$on("CollectionService.CurrentCollectionChanged", (event, collection) => {
        scope.collection = collection;
        scope.searchContext = collection ? SearchContext.Collection : SearchContext.Project;
      });

      scope.$on("Search.SearchExecuted", () => {
        scope.searchMode = SearchMode.Basic;
        hide();
      });

      scope.$on("SearchModeChanged", (e, mode) => scope.searchMode = mode);

      scope.$on("SearchContext.Changed", (e, context) => {
        if (context == SearchContext.Project) {
          scope.collection = null;
        } else {
          scope.collection = collectionService.GetCurrentCollection();
        }
        scope.searchContext = context;

        // Rebuild for the new context's field list, keeping the loaded saved search's identity.
        const prev = scope.advancedSearch;
        if (prev.context !== context) {
          scope.advancedSearch = Object.assign(new AdvancedSearchModel(context, prev.expression),
            _.pick(prev, "id", "name", "visibility", "accounts", "roles", "createdBy", "dirty"));
        }
      });

      // Saved search run from the side nav: load a copy into the builder so it can be edited and re-run.
      scope.$on("Search.SearchExecuted.Externally", (e, search) => {
        scope.advancedSearch = AdvancedSearchModel.From(search);
        $rootScope.$broadcast("Search.SearchExecuted", {advanced: true, expression: scope.advancedSearch.expression});
      });
    };
  }
}

frontendApp.directive("iioAdvancedSearch", ["$rootScope", "ProjectService", "CollectionService", Factory.Create(AdvancedSearch)]);
